import { throttle } from "nodash"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"

export default function useThrottledDispatch(dispatchFrequencyInMs = 1000) {
    const dispatch = useDispatch()

    const throttledDispatch = useMemo(
        () => throttle((action) => dispatch(action), dispatchFrequencyInMs),
        [dispatch, dispatchFrequencyInMs]
    )

    useEffect(() => () => throttledDispatch.cancel(), [throttledDispatch])

    return {
        dispatch,
        throttledDispatch,
    }
}
